import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type {
    ApiOnsideInvoiceContentData,
    ApiOnsideInvoiceData,
    OnsideInvoiceContentFilter,
    OnsideInvoiceFilter,
} from "./types";

interface OnsideInvoicesResponse {
    data: ApiOnsideInvoiceData[];
}

interface OnsideInvoiceContentsResponse {
    data: ApiOnsideInvoiceContentData[];
}

/** Транспортный слой OMP — НС и состав НС. */
export const onsideInvoicesApi = {
    /**
     * Загружает НС по фильтру.
     * @param params фильтр НС
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            filter?: OnsideInvoiceFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiOnsideInvoiceData[]> => {
        const data = await ompApiClient.postOmega<OnsideInvoicesResponse>(
            "stock/onsideInvoice.loadByFilter",
            params,
            config,
        );

        return data.data;
    },

    /** Состав НС. */
    content: {
        /**
         * Загружает строки состава НС.
         * @param params фильтр состава НС
         * @param config опции HTTP-запроса
         */
        load: async (
            params: {
                filter?: OnsideInvoiceContentFilter;
            },
            config?: RequestConfig,
        ): Promise<ApiOnsideInvoiceContentData[]> => {
            const data = await ompApiClient.postOmega<OnsideInvoiceContentsResponse>(
                "stock/onsideInvoice/contents.loadByFilter",
                params,
                config,
            );

            return data.data;
        },

        /**
         * Выставляет признак «Подтверждение выдачи» у строки состава НС.
         * @param params код строки и значение признака
         * @param config опции HTTP-запроса
         */
        setConfirmLeave: async (
            params: {
                code: number;
                confirmLeave: boolean;
            },
            config?: RequestConfig,
        ): Promise<void> => {
            await ompApiClient.postOmega("stock/onsideInvoice/contents.setConfirmLeave", params, config);
        },
    },
} as const;
